<div class="container-fluid mt-4">
  @if (item.type==='form') {
    <app-form [form] = "item" [processId] = "processId" [createDate]="createDate" (onRowKeyValue)="emitChange($event, index)"
      [singleSave] = 'singleSave'
      (onSingleSaveClick)="singleSaveClick($event)"
    [taskKey]="taskKey"></app-form>
  }

  <!--<app-file-upload-element *ngIf="element.type==='fileupload'" [fileupload] = "element"></app-file-upload-element>-->
</div>
